/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Rate_TtsInputs */

const en_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.000050 / char`)
};

const fr_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,000050 $ / caractère`)
};

const de_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,000050 $ / Zeichen`)
};

const it_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0,000050 / carattere`)
};

const ru_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0,000050 долл. США / символ`)
};

const es_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.000050 / carácter`)
};

const zh_cn2_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.000050/字符`)
};

const ja_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0.000050ドル / 文字`)
};

const hi_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0.000050 / चार`)
};

const pt_pt2_usage_rate_tts = /** @type {(inputs: Usage_Rate_TtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$0,000050 / caractere`)
};

/**
* | output |
* | --- |
* | "$0.000050 / char" |
*
* @param {Usage_Rate_TtsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_rate_tts = /** @type {((inputs?: Usage_Rate_TtsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Rate_TtsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_rate_tts(inputs)
	if (locale === "de") return de_usage_rate_tts(inputs)
	if (locale === "it") return it_usage_rate_tts(inputs)
	if (locale === "ru") return ru_usage_rate_tts(inputs)
	if (locale === "es") return es_usage_rate_tts(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_rate_tts(inputs)
	if (locale === "ja") return ja_usage_rate_tts(inputs)
	if (locale === "hi") return hi_usage_rate_tts(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_rate_tts(inputs)
	return en_usage_rate_tts(inputs)
});